export const SET_ROLE = 'SET_ROLE'

export const SET_SURVEY_ROLE = 'SET_SURVEY_ROLE'

export const SET_ATTENTION = 'SET_ATTENTION'

export const SET_GUIDE_PAGE = 'SET_GUIDE_PAGE'

export const SET_SURVEY_TYPE = 'SET_SURVEY_TYPE'



// WEBPACK FOOTER //
// ./src/store/mutation-types.js